<script setup lang="ts">
import { useEditor, EditorContent } from '@tiptap/vue-3'
import type { Extensions, JSONContent } from "@tiptap/core";
import { generateHTML } from "@tiptap/html";

const { t } = useI18n()

const props = defineProps<{
  content: JSONContent | null
  extensions: Extensions
  limit?: number
  editable?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:content', value: JSONContent | null): void,
}>()

const editor = useEditor({
  content: props.content,
  extensions: props.extensions,
  editable: props.editable,
  onUpdate: () => {
    emit("update:content", editor.value?.getJSON() ?? null)
  }
})

watch(() => props.content, (val) => {
  if (JSON.stringify(editor.value?.getJSON()) == JSON.stringify(val)) {
    return
  }
  editor.value?.commands?.setContent(val, false)
})

watch(() => props.editable, (curr) => {
  editor.value?.setOptions({ editable : curr })
})

const html = computed(() => props.content == null ? null : generateHTML(props.content, props.extensions))

onBeforeUnmount(() => unref(editor)?.destroy())
</script>

<template>
  <div v-if="editor" class="editor flex flex-col">
    <client-only>
      <slot :editor="editor!" />
      <EditorContent :editor="editor" />
      <div
        v-if="editor.view.editable && editor.storage.characterCount && props.limit"
        class="flex flex-row ml-auto mt-2"
      >
        <span
          class="b2 opacity-50"
        >
          {{ t('jc.component.editor.usedChars', { currentChars: editor.storage.characterCount.characters(), maxChars: props.limit}) }}
        </span>
      </div>

      <template #fallback>
        foobar
        <div
          v-if="html"
          v-html="html"
        />
      </template>
    </client-only>
  </div>
</template>

<style scoped lang="postcss">

</style>
